import { Injectable } from '@angular/core';

export type JourneyStep = {
  title: string;
  text: string;
  iconClass: string;
};

export type JourneyContent = {
  badge: string;
  heading: string;
  lede: string;
  steps: JourneyStep[];
};

@Injectable({ providedIn: 'root' })
export class JourneySectionService {
  readonly content: JourneyContent = {
    badge: 'Unified Pet-Care Journey',
    heading: 'Every service connected, every visit remembered.',
    lede:
      'Grooming, day care, clinic, and commerce share one pet profile, one timeline, and one checkout so parents never repeat details and teams stay perfectly aligned.',
    steps: [
      {
        title: 'Book once',
        text: 'Pick the services, staff, and timing in a single guided flow.',
        iconClass: 'journey__icon journey__icon--iris'
      },
      {
        title: 'Care in sync',
        text: 'Notes and preferences move with your pet across every service.',
        iconClass: 'journey__icon journey__icon--green'
      },
      {
        title: 'Shop with context',
        text: 'Recommended essentials follow clinical guidance and grooming needs.',
        iconClass: 'journey__icon journey__icon--amber'
      },
      {
        title: 'One checkout',
        text: 'Pay once and receive every update in the same timeline.',
        iconClass: 'journey__icon journey__icon--rose'
      }
    ]
  };
}
